import { render, staticRenderFns } from "./ConfigurationNew.vue?vue&type=template&id=47abf6f2"
import script from "./ConfigurationNew.vue?vue&type=script&lang=js"
export * from "./ConfigurationNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports